import { render, staticRenderFns } from "./EcosurveyIngestionSchemaColumn.vue?vue&type=template&id=5c8d2f08&scoped=true"
import script from "./EcosurveyIngestionSchemaColumn.vue?vue&type=script&lang=js"
export * from "./EcosurveyIngestionSchemaColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d2f08",
  null
  
)

export default component.exports